var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RADIUS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #RADIUS .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #RADIUS .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_361",
    "data-name": "Pfad 361",
    className: "cls-1",
    d: "M25.9,12.3V5.9H19.5L22,8.4h0l-4,4.1-.7.7a3.159,3.159,0,0,1,1.4,1.4l.7-.7,4.1-4.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_995",
    "data-name": "Gruppe 995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_362",
    "data-name": "Pfad 362",
    className: "cls-2",
    d: "M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm0,30A14.028,14.028,0,0,1,2,16.4H12a4.011,4.011,0,0,0,8-.4,3.7,3.7,0,0,0-.6-2.1A3.159,3.159,0,0,0,18,12.5a4.228,4.228,0,0,0-2-.5,4.082,4.082,0,0,0-4,3.4H2A14.006,14.006,0,1,1,16,30ZM13,16a1.268,1.268,0,0,1,.1-.6A2.833,2.833,0,0,1,16,13a5.019,5.019,0,0,1,1.2.2,3.159,3.159,0,0,1,1.4,1.4A2.3,2.3,0,0,1,19,16a2.946,2.946,0,0,1-3,3,3.019,3.019,0,0,1-3-2.6h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_371",
    "data-name": "Ellipse 371",
    className: "cls-2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(14 14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadius);
export default __webpack_public_path__ + "static/media/radius.352f18531134efbe4891f9f79d620dd0.svg";
export { ForwardRef as ReactComponent };